import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Link from '@material-ui/core/Link';
import api from '../../lib/api';

// Простые SVG иконки для показа/скрытия пароля
const VisibilityIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
  </svg>
);

const VisibilityOffIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
  </svg>
);

class ModeratorRegistration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      name: '',
      lastName: '',
      error: null,
      success: false,
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
    this.handleClickShowConfirmPassword = this.handleClickShowConfirmPassword.bind(this);
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleClickShowConfirmPassword = () => {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  };

  handleChange(field) {
    return (event) => {
      this.setState({ [field]: event.target.value, error: null });
    };
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.state.email || !this.state.password || !this.state.confirmPassword || !this.state.name) {
      this.setState({ error: 'Заполните все обязательные поля' });
      return;
    }

    // Простая валидация email
    if (!this.state.email.includes('@') || !this.state.email.includes('.')) {
      this.setState({ error: 'Неверный формат email' });
      return;
    }

    // Проверка совпадения паролей
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ error: 'Пароли не совпадают' });
      return;
    }

    // Проверка минимальной длины пароля
    if (this.state.password.length < 6) {
      this.setState({ error: 'Пароль должен содержать минимум 6 символов' });
      return;
    }

    this.setState({ loading: true, error: null });

    try {
      await api.registerModerator({
        email: this.state.email.trim(),
        password: this.state.password,
        name: this.state.name.trim(),
        lastName: this.state.lastName.trim() || null,
      });

      this.setState({ success: true, loading: false });
    } catch (err) {
      this.setState({
        error: err.message || 'Ошибка при регистрации. Попробуйте позже.',
        loading: false,
      });
    }
  }

  render() {
    const { classes } = this.props;

    if (this.state.success) {
      return (
        <div className={classes.container}>
          <Paper className={classes.loginPaper} elevation={2}>
            <Typography variant="h5" gutterBottom>
              Регистрация успешна!
            </Typography>
            <Typography variant="body1" paragraph>
              Мы отправили письмо на адрес <strong>{this.state.email}</strong>
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              Пожалуйста, проверьте вашу почту и перейдите по ссылке для подтверждения регистрации.
            </Typography>
            <div className={classes.submitContainer}>
              <Link href="/login" color="primary">
                Вернуться к входу
              </Link>
            </div>
          </Paper>
        </div>
      );
    }

    return (
      <div className={classes.container}>
        <Paper className={classes.loginPaper} elevation={2}>
          <form onSubmit={this.handleSubmit}>
            <Typography variant="h5" gutterBottom>
              Регистрация менеджера
            </Typography>
            <TextField
              id="email"
              value={this.state.email}
              label="Email *"
              fullWidth
              margin="normal"
              type="email"
              onChange={this.handleChange('email')}
              error={!!this.state.error}
            />
            <TextField
              id="password"
              value={this.state.password}
              label="Пароль *"
              margin="normal"
              fullWidth
              onChange={this.handleChange('password')}
              type={this.state.showPassword ? 'text' : 'password'}
              error={!!this.state.error}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="переключить видимость пароля"
                      onClick={this.handleClickShowPassword}
                      edge="end"
                    >
                      {this.state.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              id="confirmPassword"
              value={this.state.confirmPassword}
              label="Подтверждение пароля *"
              margin="normal"
              fullWidth
              onChange={this.handleChange('confirmPassword')}
              type={this.state.showConfirmPassword ? 'text' : 'password'}
              error={!!this.state.error}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="переключить видимость подтверждения пароля"
                      onClick={this.handleClickShowConfirmPassword}
                      edge="end"
                    >
                      {this.state.showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              id="name"
              value={this.state.name}
              label="Имя *"
              fullWidth
              margin="normal"
              onChange={this.handleChange('name')}
              error={!!this.state.error}
            />
            <TextField
              id="lastName"
              value={this.state.lastName}
              label="Фамилия"
              fullWidth
              margin="normal"
              onChange={this.handleChange('lastName')}
            />
            {this.state.error && (
              <Typography variant="body2" color="error" style={{ marginTop: 10 }}>
                {this.state.error}
              </Typography>
            )}
            <div className={classes.submitContainer}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={this.state.loading}
              >
                {this.state.loading ? 'Регистрация...' : 'Зарегистрироваться'}
              </Button>
            </div>
            <div className={classes.submitContainer} style={{ marginTop: 10 }}>
              <Link href="/login" color="primary">
                Уже есть аккаунт? Войти
              </Link>
            </div>
          </form>
        </Paper>
      </div>
    );
  }
}

const styles = () => ({
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginPaper: {
    width: 400,
    padding: 25,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  submitContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 15,
  },
});

const Styled = withStyles(styles)(ModeratorRegistration);

export default Styled;

